function numToEn(num) {
  if (num == 0) {
    return "A";
  } else if (num == 1) {
    return "B";
  } else if (num == 2) {
    return "C";
  } else if (num == 3) {
    return "D";
  } else if (num == 4) {
    return "E";
  } else if (num == 5) {
    return "F";
  } else if (num == 6) {
    return "G";
  } else if (num == 7) {
    return "H";
  } else if (num == 8) {
    return "I";
  } else if (num == 9) {
    return "J";
  }
}

function numToEns(str) {
  var newstr = "";
  if (str != -1) {
    var arr = str.split(",");
    for (var i = 0; i < arr.length; i++) {
      newstr += numToEn(arr[i]);
    }
  } else {
    newstr = "未作答";
  }
  return newstr;
}

function calTime(time) {
  if (time <= 0) {
    return "00:00:00";
  }
  let result = parseInt(time);
  let h =
    Math.floor(result / 3600) < 10
      ? "0" + Math.floor(result / 3600)
      : Math.floor(result / 3600);
  let m =
    Math.floor((result / 60) % 60) < 10
      ? "0" + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  let s =
    Math.floor(result % 60) < 10
      ? "0" + Math.floor(result % 60)
      : Math.floor(result % 60);
  // result = `${h}:${m}:${s}`
  result = h + ":" + m + ":" + s;
  return result;
}
function calTime_(time) {
  let result = parseInt(time);
  let h =
    Math.floor(result / 3600) < 10
      ? "0" + Math.floor(result / 3600)
      : Math.floor(result / 3600);
  let m =
    Math.floor((result / 60) % 60) < 10
      ? "0" + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  let s =
    Math.floor(result % 60) < 10
      ? "0" + Math.floor(result % 60)
      : Math.floor(result % 60);
  // result = `${h}:${m}:${s}`
  result = m + ":" + s;
  return result;
}
function calTime_chinese(time) {
  if (time >= 0 && time < 1) {
    return time + "秒";
  }
  let result = parseInt(time);
  let h = Math.floor(result / 3600);
  let m = Math.floor((result / 60) % 60);
  let s = Math.floor(result % 60);
  result = `${h == 0 ? "" : h + "时"}${m == 0 ? "" : m + "分"}${
    s == 0 ? "" : s + "秒"
  }`;
  return result;
}

function filter_mock_status(status) {
  if (status == 1) {
    return "立即报名";
  } else if (status == 2) {
    return "开始考试";
  } else if (status == 3) {
    return "考试结束";
  } else if (status == 4) {
    return "查看成绩";
  } else if (status == 5) {
    return "已过期";
  } else if (status == 6) {
    return "等待下一场";
  }
}

function filter_time(str) {
  let y = str.substring(0, 4);
  let m = str.substring(4, 6);
  let d = str.substring(6);
  return y + "-" + m + "-" + d + "  ";
}

function filterAllScore(arr) {
  let all_score = 0;
  if (arr.length) {
    let a = arr.filter((item) => {
      return item.name == "总分";
    });
    if (a.length) {
      all_score = a[0].score;
    }
  }
  return all_score;
}

const dayjs = require("dayjs");
// 时间戳》年月日时分秒
function filterDayJSymd(val) {
  return dayjs(val * 1000).format("YYYY年MM月DD日 HH:mm:ss");
}
export {
  numToEn,
  numToEns,
  calTime,
  filter_mock_status,
  filter_time,
  calTime_,
  filterAllScore,
  calTime_chinese,
  filterDayJSymd,
};
